import React, { useState } from 'react';
import AttenteRequete from '../../../hoc/AttenteRequete/AttenteRequete';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import * as requestType from '../../../ressources/glossaires/glossaire_requetes';
import * as s from '../../../ressources/StyleGlobal/StyleGlobal';
import Bouton from '../../UI/Bouton/Bouton';
import FormulaireSelectionProjetsArborecenseUtilisateur from '../../UI/FormulaireSelectionProjetsArborecenseUtilisateur/FormulaireSelectionProjetsArborecenseUtilisateur';
import styles from './AjouterUtilisateur.module.scss';
import FormulairePersonalisationPrivileges from './FormulairePersonalisationPrivileges/FormulairePersonalisationPrivileges';

const AjouterUtilisateur = ({
  ajouter,
  indicatifTelephone: defaultIndicatif,
}) => {
  const [nom, setNom] = useState('');
  const [prenom, setPrenom] = useState('');
  const [emailDebut, setEmailDebut] = useState('');
  const [emailFin, setEmailFin] = useState('');
  const [indicatifTelephone, setIndicatifTelephone] = useState(
    defaultIndicatif || ''
  );
  const [telephone, setTelephone] = useState('');
  const [entreprise, setEntreprise] = useState('');
  const [privileges_list, setPrivilegesList] = useState([]);
  const [projects_list_id, setProjectsList] = useState([]);

  const gererEtatDeCibleName = (event) => {
    const { name, value } = event.target;
    switch (name) {
      case 'nom':
        setNom(value);
        break;
      case 'prenom':
        setPrenom(value);
        break;
      case 'emailDebut':
        setEmailDebut(value);
        break;
      case 'emailFin':
        setEmailFin(value);
        break;
      case 'indicatifTelephone':
        setIndicatifTelephone(value);
        break;
      case 'telephone':
        setTelephone(value);
        break;
      case 'entreprise':
        setEntreprise(value);
        break;
      default:
        break;
    }
  };

  const gererPrivilegesList = (newPrivilegesList) => {
    setPrivilegesList(newPrivilegesList);
  };

  const gererProjetsList = (newProjectsList) => {
    setProjectsList(newProjectsList);
  };

  const gererEnvoi = (event) => {
    event.preventDefault();
    const formulaireCreerUtilisateur = {
      login_name: `${emailDebut}@${emailFin}`,
      lastname: nom,
      name: prenom,
      email: `${emailDebut}@${emailFin}`,
      phone_index: indicatifTelephone,
      phone_number: telephone,
      company_name: entreprise,
      privileges_list,
      projects_list_id,
    };
    ajouter(formulaireCreerUtilisateur);
  };

  return (
    <div className={styles.ConteneurInfo}>
      <div className={[s.container, s.text_left, styles.Formulaire].join(' ')}>
        <form onSubmit={gererEnvoi}>
          <div className={s.form_group}>
            <div className={s.form_row}>
              <div className={s.col_sm_12}>
                <label className={[s.card_header, styles.style].join(' ')}>
                  {checkMot('nom')}
                </label>
                <input
                  type="text"
                  className={[s.form_control, styles.Input].join(' ')}
                  placeholder="nom"
                  name="nom"
                  value={nom}
                  onChange={gererEtatDeCibleName}
                  required
                />
              </div>
              <div className={s.col_sm_12}>
                <label className={[s.card_header, styles.style].join(' ')}>
                  {checkMot('prenom')}
                </label>
                <input
                  type="text"
                  className={[s.form_control, styles.Input].join(' ')}
                  placeholder="prenom"
                  name="prenom"
                  value={prenom}
                  onChange={gererEtatDeCibleName}
                  required
                />
              </div>
            </div>
          </div>

          <label className={[s.card_header, styles.style].join(' ')}>
            {checkMot('email')}
          </label>
          <div className={s.form_group}>
            <div className={[s.form_row, s.align_items_center].join(' ')}>
              <div className={s.col_5}>
                <input
                  type="text"
                  className={[s.form_control, s.mb_2, styles.Input].join(' ')}
                  placeholder="exemple"
                  name="emailDebut"
                  value={emailDebut}
                  onChange={gererEtatDeCibleName}
                  required
                />
              </div>
              <div className={s.col_7}>
                <div className={[s.input_group, s.mb_2].join(' ')}>
                  <div className={s.input_group_prepend}>
                    <div
                      className={[
                        s.input_group_text,
                        s.form_control,
                        styles.Input,
                      ].join(' ')}
                    >
                      @
                    </div>
                  </div>
                  <input
                    className={[s.form_control, styles.Input].join(' ')}
                    type="text"
                    name="emailFin"
                    value={emailFin}
                    onChange={gererEtatDeCibleName}
                    pattern="([àáâãäåæçèéêëìíîïñòóôõöœùúûü_0-9a-zA-Z\-]{1,}\.)+[a-zA-Z]{2,}"
                    placeholder="nomDeDomaine"
                    required
                  />
                </div>
              </div>
            </div>
          </div>

          <div className={s.form_group}>
            <div className={s.form_row}>
              <div className={s.col}>
                <label className={[s.card_header, styles.style].join(' ')}>
                  {checkMot('entreprise')}
                </label>
                <input
                  type="text"
                  className={[s.form_control, s.mb_2, styles.Input].join(' ')}
                  placeholder="entreprise"
                  name="entreprise"
                  value={entreprise}
                  onChange={gererEtatDeCibleName}
                />
              </div>
            </div>
          </div>

          <div className={s.form_group}>
            <label className={[s.card_header, styles.style].join(' ')}>
              {checkMot('telephone')}
            </label>
            <div className={s.form_row}>
              <div className={s.col_sm_4}>
                <input
                  name="indicatifTelephone"
                  value={indicatifTelephone}
                  type="number"
                  size="5"
                  placeholder="index"
                  pattern="([0-9])*"
                  className={[s.form_control, s.mr_sm_2, styles.Input].join(
                    ' '
                  )}
                  onChange={gererEtatDeCibleName}
                />
              </div>
              <div className={s.col_sm_8}>
                <div className={[s.input_group, s.mb_2].join(' ')}>
                  <div className={s.input_group_prepend}>
                    <div
                      className={[
                        s.input_group_text,
                        s.form_control,
                        styles.Input,
                      ].join(' ')}
                    >
                      <svg
                        width="1em"
                        height="1em"
                        viewBox="0 0 16 16"
                        className="bi bi-telephone-fill"
                        fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          d="M2.267.98a1.636 1.636 0 0 1 2.448.152l1.681 2.162c.309.396.418.913.296 1.4l-.513 2.053a.636.636 0 0 0 .167.604L8.65 9.654a.636.636 0 0 0 .604.167l2.052-.513a1.636 1.636 0 0 1 1.401.296l2.162 1.681c.777.604.849 1.753.153 2.448l-.97.97c-.693.693-1.73.998-2.697.658a17.47 17.47 0 0 1-6.571-4.144A17.47 17.47 0 0 1 .639 4.646c-.34-.967-.035-2.004.658-2.698l.97-.969z"
                        />
                      </svg>
                    </div>
                  </div>
                  <input
                    className={[s.form_control, s.mb_2, styles.Input].join(' ')}
                    value={telephone}
                    onChange={gererEtatDeCibleName}
                    pattern="([0-9])*"
                    name="telephone"
                    placeholder="telephone"
                  />
                </div>
              </div>
            </div>
          </div>

          <label className={s.card_header}>
            <FormulairePersonalisationPrivileges
              gererPrivilegesList={gererPrivilegesList}
            />
          </label>

          <label className={s.card_header}>
            <FormulaireSelectionProjetsArborecenseUtilisateur
              gererProjetsList={gererProjetsList}
            />
          </label>

          <div className={s.form_group}>
            <div className={[s.d_flex, s.justify_content_between].join(' ')}>
              <div></div>
              <div>
                <AttenteRequete
                  request_type={requestType.creation_d_un_utilisateur}
                  str="Creation en cour"
                >
                  <Bouton type="submit">{checkMot('creer')}</Bouton>
                </AttenteRequete>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AjouterUtilisateur;
